import {StyledAgendaButtonFilterSelection} from '@/features/agenda/components/agenda-button-filter-selection/style'
import {ButtonProps} from '@ariakit/react'
import {ReactNode} from 'react'

type AgendaButtonFilterSelectionProps = ButtonProps & {
    isSelected?: boolean
    children: ReactNode
}

export const AgendaButtonFilterSelection = ({isSelected, children, ...props}: AgendaButtonFilterSelectionProps) => {
    return (
        <StyledAgendaButtonFilterSelection
            {...props}
            $isSelected={!!isSelected}
            size="sm"
            variant="ghost"
            shape="rectangle"
        >
            {children}
        </StyledAgendaButtonFilterSelection>
    )
}
